import styled, { css } from 'styled-components'
import { ButtonProps } from './index'

export const ClearButton = styled.button<ButtonProps>``

export const DefaultButton = styled(ClearButton)`
  cursor: pointer;
  display: block;
  font-size: 1.125rem;
  min-width: 9rem;
  color: #FFFFFF;
  font-weight: 500;
  font-family: 'Montserrat', sans-serif;
  border-radius: 0.5rem;
  border: 0;
  outline: none;
  // background-color: ${props => props.theme.primaryBlue};
  background-color: #41AADA;
  //padding: 0.875rem 2.25rem;
  padding: 0.875rem 1.5rem;
  transition: 0.5s all ease-out;
  box-shadow: 0 2px 6px 0 rgba(0,0,0,0.24);
  text-align: center;
  text-decoration: none;
  
  &:hover {
    background-color: #27B3F3;
  }
  
  ${props =>
    props.disabled &&
    css`
      cursor: auto;
      background-color: #b4d7e7;

      &:hover {
        background-color: #b4d7e7;
      }
    `}
`

export const SecondaryButton = styled(DefaultButton)`
  color: #41aada;
  background-color: #ffffff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.24);

  &:hover {
    background-color: #f7f9fc;
  }

  ${props =>
    props.disabled &&
    css`
      background-color: #f7f9fc;

      &:hover {
        background-color: #f7f9fc;
      }
    `}
`

export const TextButton = styled(DefaultButton)`
  color: #41aada;
  font-size: 1rem;
  font-weight: 600;
  background-color: transparent;
  border: none;
  box-shadow: none;
  padding-left: 0;
  padding-right: 0;

  &:hover {
    color: #27b3f3;
    background-color: transparent;
  }

  ${props =>
    props.disabled &&
    css`
      background-color: transparent;

      &:hover {
        background-color: transparent;
      }
    `}
`

export const TextDangerButton = styled(TextButton)`
  color: #d83742;

  &:hover {
    color: #d83742;
  }
`
export const Empty = styled(TextButton)``
